import {
    listOrders_orders_edges_node,
    listOrders_orders_edges_node_guest,
    listOrders_orders_edges_node_user
} from './graphql/listOrders';

import { listOffers_offers_edges_node_OfferTemplate , Pos } from './graphql/listOffers';

import { OfferTemplateWithdrawalType, OfferTemplateKind } from "./graphql/globalTypes";

export type AppOrderState = OrderState | LocalOrderState;

export enum LocalOrderState {
    LATE = 'LATE',
    URGENT = 'URGENT',
}

// States managed by the application, excludes "CART" and "ON_HOLD"
export enum OrderState {
    ACCEPTED = 'ACCEPTED',
    PREPARING = 'PREPARING',
    READY = 'READY',
    COMPLETED = 'COMPLETED',
    REFUSED = 'REFUSED',
    CANCELLED = 'CANCELLED',
    ABANDONED = 'ABANDONED'
}

export enum WithdrawalTypeChoice {
    ON_SITE = 'ON_SITE',
    TAKE_AWAY = 'TAKE_AWAY',
}

// @ts-ignore
export interface IOrder extends listOrders_orders_edges_node {
    withdrawRange: [Date, Date];
    isUrgent?: boolean;
    isLate?: boolean;
    tableNumber: number | null;
    pickupPoint: IPickupPoint | null;
    offer: IOffer;
    comment: string | null;
    guest: listOrders_orders_edges_node_guest;
    user?: listOrders_orders_edges_node_user;
    withdrawalType: WithdrawalTypeChoice | null;
    cleaningTime: string | null;
    consumptionPoint: IConsumptionPointNode | null;
}

export interface IConsumptionPointNode {
    id: string;
    translations: { language: string; name: string | null }[];
}

export interface IOfferTemplate {
    id: string;
    value: string;
    name: string;
    label: listOffers_offers_edges_node_OfferTemplate['name'];
    secondaryLabel: string | undefined;
    withdrawalType: OfferTemplateWithdrawalType | null;
    kind: OfferTemplateKind;
    daysInAdvanceEnd: number | null;
    offers: any[];
    pos: Pos;
}

export interface IOffer {
    id: string;
    value: string;
    label: listOffers_offers_edges_node_OfferTemplate['name'];
    secondaryLabel: string | undefined;
    offerTemplateId: string;
    withdrawalType: OfferTemplateWithdrawalType | null;
    kind: OfferTemplateKind;
    consumptionPoints: IConsumptionPointNode[];
    isInAdvance: boolean;
    withdrawRange: string;
    offerTemplateOffers?: any;
    count?: number;
    offerTemplate: IOfferTemplate
}

export interface IOfferWithOrder {
    id: string;
    value: string;
    label: string;
    secondaryLabel: string | undefined;
    offerTemplateId: string;
    withdrawalType: OfferTemplateWithdrawalType | null;
    isInAdvance: boolean;
    withdrawRange: string;
    count?: number;
}

export interface IPickupPoint {
    id: string;
    name: string
}
